import { Subscription } from "src/interfaces/Subscription";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SubscriptionsState {
  subscriptions: Subscription[];
  isSubscribed: boolean;
}

const initialState: SubscriptionsState = {
  subscriptions: [],
  isSubscribed: false,
};

export const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setSubscriptions: (state, action: PayloadAction<Subscription[]>) => {
      state.subscriptions = action.payload;
      state.isSubscribed = true;
    },
  },
});

export const { setSubscriptions } = subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
